/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_AutonomyInputs */

const en_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const ar_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#استقلالية`)
};

const bn_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const de_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const es_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const fr_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const pt_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const zh_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const tr_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const ru_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

const pl_svtag_autonomy = /** @type {(inputs: Svtag_AutonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AUTONOMY`)
};

/**
* | output |
* | --- |
* | "#AUTONOMY" |
*
* @param {Svtag_AutonomyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_autonomy = /** @type {((inputs?: Svtag_AutonomyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_AutonomyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_autonomy(inputs)
	if (locale === "bn") return bn_svtag_autonomy(inputs)
	if (locale === "de") return de_svtag_autonomy(inputs)
	if (locale === "es") return es_svtag_autonomy(inputs)
	if (locale === "fr") return fr_svtag_autonomy(inputs)
	if (locale === "pt") return pt_svtag_autonomy(inputs)
	if (locale === "zh") return zh_svtag_autonomy(inputs)
	if (locale === "tr") return tr_svtag_autonomy(inputs)
	if (locale === "ru") return ru_svtag_autonomy(inputs)
	if (locale === "pl") return pl_svtag_autonomy(inputs)
	return en_svtag_autonomy(inputs)
});